import {ConceptListItem, SearchConcepts, ConceptsParams} from './concepts';
import {ConceptType} from './concept-types';
import {ConceptDataSource} from '../../administration/admin-concept-lists/concept-data-source';
import {CmsApiService} from '../cms-api.service';
import {CheckFilterGroup} from './search-objects';
import {ConceptsContainerIf} from "./concepts-container-if";

export class ConceptsContainer implements ConceptsContainerIf {

  constructor(private readonly cms: CmsApiService) {
  }
  allSelected = false;
  concepts: SearchConcepts;
  conceptsParams: ConceptsParams;
  conceptType: ConceptType;
  firstSelectedConcept: ConceptListItem;
  loadingConcepts = false;
  showLinkToObject = false;
  openLinkAsTab = false;
  linkToObject: string = '/artifact';
  parentConcepts: Array<ConceptListItem> = [];
  selected: Array<ConceptListItem> = [];
  conceptDataSource: ConceptDataSource = new ConceptDataSource(this.cms);
  pageIndex = 0;
  reload = 0.1;

  filterGroups: CheckFilterGroup[] = [];
}
